var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project content" },
    [
      _c(
        "carousel",
        { attrs: { events: _vm.events, progressColor: _vm.mainColor } },
        [_vm._t("slides")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inner-content", attrs: { id: "project-content" } },
        [
          _c("h1", { staticClass: "template-title" }, [_vm._t("title")], 2),
          _vm._v(" "),
          _vm._t("main-content")
        ],
        2
      ),
      _vm._v(" "),
      _c("svg", { staticClass: "in", attrs: { id: "transition-overlay" } }, [
        _c("rect")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }